import { PageHeader } from '@/components/PageHeader';
import { SystemHealthDashboard } from '@/components/SystemHealthDashboard';

export default function SystemMonitoring() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="System Monitoring"
        description="Monitor system health, performance, and AI provider status"
      />
      <SystemHealthDashboard />
    </div>
  );
}